/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Open_SampleInputs */

const en_gc_home_open_sample = /** @type {(inputs: Gc_Home_Open_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this sample`)
};

const zh_gc_home_open_sample = /** @type {(inputs: Gc_Home_Open_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开这个示例`)
};

/**
* | output |
* | --- |
* | "Open this sample" |
*
* @param {Gc_Home_Open_SampleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_open_sample = /** @type {((inputs?: Gc_Home_Open_SampleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Open_SampleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_open_sample(inputs)
	return zh_gc_home_open_sample(inputs)
});
export { gc_home_open_sample as "gc.home.open_sample" }